import { QuestionFormDraft } from '../pages/Schedule/RegistrationSetup/forms/CustomForm/types'

/**
 * Validates a question form draft to determine if all required fields are filled
 *
 * @param formData - The question form draft to validate
 * @returns boolean - true if the form is valid and save button should be enabled
 */
export const isQuestionFormValid = (formData: QuestionFormDraft): boolean => {
  console.log('🔄 isQuestionFormValid: Validating form data', { formData })

  // All question types require a non-empty label
  if (!formData.label.trim()) {
    console.log('🔄 isQuestionFormValid: Label is empty, form invalid')
    return false
  }

  // Choice questions (dropdown) require at least one option with a non-empty label
  if (formData.type === 'dropdown') {
    const hasValidOption = formData.options.some((option) =>
      option.label.trim()
    )
    if (!hasValidOption) {
      console.log(
        '🔄 isQuestionFormValid: Dropdown has no valid options, form invalid'
      )
      return false
    }
  }

  // All other question types only require the label to be filled
  // Number type: min/max are optional
  // Text-like types: max_char is optional
  // Other types: no additional required fields

  console.log('🔄 isQuestionFormValid: Form is valid')
  return true
}

/**
 * Returns CSS styles for disabled button state
 *
 * @param isDisabled - Whether the button should be disabled
 * @returns CSS object with appropriate styles
 */
export const getDisabledButtonStyles = (isDisabled: boolean) => {
  return {
    opacity: isDisabled ? 0.5 : 1,
    pointerEvents: isDisabled ? 'none' : 'auto',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
  } as const
}
